// Zentrale Konfiguration für wiederverwendete Optionen

export const areaOptions = [
  'Bar', 'Bauwagen', 'Bereichsübergreifend', 'Bierstand', 'Cafe', 'DJ Zelt', 'Grill',
  'Info+Tshirts', 'Kreis Jugendring', 'Mezze', 'Musik', 'Orga', 'Pommes', 'Thai',
  'Traumwerker', 'Waffel', 'Weinzelt', 'Weißwurst'
];

export const categoryOptions = [
  'Baumaterial', 'Verpflegung', 'Fahrtkosten', 'Lebensmittel', 'Trockenware', 'Wareneinsatz', 'Sonstiges'
];

export const MAX_FILE_SIZE_MB = 10;
export const MAX_FILE_SIZE_BYTES = MAX_FILE_SIZE_MB * 1024 * 1024;

export const ALLOWED_FILE_TYPES = ['image/jpeg', 'image/png', 'image/gif', 'image/webp', 'application/pdf'];

export const isValidFileType = (file) => {
  return file.type.startsWith('image/') || file.type === 'application/pdf';
};

export const isValidFileSize = (file) => {
  return file.size <= MAX_FILE_SIZE_BYTES;
};

export const validateFile = (file) => {
  if (!isValidFileType(file)) {
    return { valid: false, error: 'Nur PDF- und Bilddateien sind erlaubt.' };
  }
  if (!isValidFileSize(file)) {
    return { valid: false, error: `Die Datei ist zu groß. Maximal ${MAX_FILE_SIZE_MB} MB erlaubt.` };
  }
  return { valid: true, error: null };
};

export const isValidAmount = (value) => {
  if (typeof value !== 'string') return false;
  const normalized = value.replace(',', '.');
  return /^(\d+)([.,]\d{1,2})?$/.test(value) && !isNaN(Number(normalized)) && Number(normalized) <= 5000;
};

export const isValidEmail = (email) => {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
};

export const isValidIBAN = (iban) => {
  const cleaned = iban.replace(/\s+/g, '').toUpperCase();
  if (cleaned.length !== 22) return false;
  if (!cleaned.startsWith('DE')) return false;
  if (!/^DE\d{20}$/.test(cleaned)) return false;
  return true;
};
